import { render, staticRenderFns } from "./previous.vue?vue&type=template&id=623ee4a8&"
import script from "./previous.vue?vue&type=script&lang=js&"
export * from "./previous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports